import {colors} from './defaultSettings';

export default {
  wrapper: {
    position: 'relative',
    // maxWidth: '140rem',
    overflow: 'hidden',
    margin: '0 auto',
  },
  container: {
    display: 'block',
    margin: '0',
    position: 'relative',
    // border: '1px solid ' + colors.border,
    background: colors.bg.bottom,
    boxShadow: '0 1px 12px rgba(6,0,18,0.065)',
    transition: 'width .28s ease-out, max-width .28s ease-out'
  },
  headerWrap: {

  },
  cellsWrap: {

  },
  sidebarWrap: {
    position: 'absolute',
    right: 0,
    top: 0,
    bottom: 0,
    left: 'auto',
    width: '30px',
    background: colors.bg.layer1,
  },
  tableContainer: {
    // minHeight: '400px',
    overflow: 'hidden',
    transition: 'width .28s ease-out' ,
  },
  loaderWrap: {
    position: 'relative',
    height: '50vh',
    width: '100%',
    background: '#fff',
    boxShadow: '0 2px 10px rgba(0,0,0,0.12)'
  },
  updateOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    background: 'rgba(255,255,255,0.5)',
    zIndex: 25,
  },
  headerBackground: {
    background: colors.bg.header,
    height: '56px',
    width: '100%',
    position: 'absolute'
  }
}
